import { motion } from "framer-motion";
import { Star, BadgeCheck } from "lucide-react";

const reviews = [
  {
    name: "Ricardo Almeida",
    role: "Comprou um BMW X6",
    text: "Simulei no site de madrugada, a IA já me respondeu no WhatsApp e no dia seguinte estava assinando o contrato. Nunca vi processo tão rápido.",
  },
  {
    name: "Fernanda Costa",
    role: "Comprou um GLE 450",
    text: "Deram meu carro na troca com avaliação justa e transparente. Tudo digital, sem pegadinha. A parcela ficou exatamente como o simulador mostrou.",
  },
  {
    name: "Paulo Henrique",
    role: "Lojista parceiro",
    text: "Uso a plataforma ERP + CRM da Seed na minha revenda. Estoque, anúncios, leads e financeiro em um lugar só. Minha equipe vende 40% mais.",
  },
];

export const Testimonials = () => (
  <section className="py-24 sm:py-32 bg-[#0d0f17] border-y border-slate-800/60" data-testid="testimonials-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-100px" }}
        transition={{ duration: 0.8 }}
        className="mb-12"
      >
        <p className="text-xs font-mono2 tracking-widest uppercase text-emerald-400 mb-3">07 — Prova social</p>
        <h2 className="font-display text-3xl sm:text-5xl font-bold tracking-tight text-white">
          Quem comprou, <span className="text-emerald-400">recomenda</span>
        </h2>
      </motion.div>

      <div className="grid md:grid-cols-3 gap-6" data-testid="testimonials-grid">
        {reviews.map((r, i) => (
          <motion.figure
            key={r.name}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.7, delay: i * 0.12 }}
            className="glass rounded-3xl p-8 flex flex-col"
            data-testid={`testimonial-${i}`}
          >
            <div className="flex gap-1 mb-5">
              {[...Array(5)].map((_, s) => (
                <Star key={s} className="w-4 h-4 fill-emerald-400 text-emerald-400" />
              ))}
            </div>
            <blockquote className="text-sm text-slate-300 leading-relaxed flex-1">"{r.text}"</blockquote>
            <figcaption className="mt-6 flex items-center gap-3">
              <span className="w-10 h-10 rounded-full bg-emerald-500/15 flex items-center justify-center font-display font-bold text-emerald-400">
                {r.name[0]}
              </span>
              <div>
                <p className="text-sm font-semibold text-white flex items-center gap-1.5">
                  {r.name}
                  <BadgeCheck className="w-4 h-4 text-emerald-400" />
                </p>
                <p className="text-xs text-slate-500">{r.role}</p>
              </div>
            </figcaption>
          </motion.figure>
        ))}
      </div>
    </div>
  </section>
);
